<template lang='pug' src='./footer.pug'></template>

<script>
import Icon from 'components/icon/icon'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: '6Le4844UAAAAACJcfLTrJk8sXfilBN0wZhMXUgtu' })

export default {
  computed: {
    props () {
      return this.$store.state.acfOptions
    }
  },
  components: {
    Icon
  },
  methods: {
    recaptcha () {
      this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
    }
  },
  template: '<button @click="recaptcha">Execute recaptcha</button>'
}
</script>



// WEBPACK FOOTER //
// footer.vue?4bf15e0f